export default __webpack_public_path__ + "static/media/BlackFrame08.a86aefc2.png";